import PoolsApi from '../api/pools'
import { push } from 'react-router-redux'
import { addInfoNotification, addErrorNotification } from './notifications'

export const POOLADDEDIT_REQUESTED = 'pools/POOLADDEDIT_REQUESTED'
export const POOLADDEDIT_COMPLETED = 'pools/POOLADDEDIT_COMPLETED'
export const POOLADDEDIT_ERROR = 'pools/POOLADDEDIT_ERROR'

export const addPool = (pool) => {
  return dispatch => {
    dispatch({
      type: POOLADDEDIT_REQUESTED,
      payload: pool
    })

    PoolsApi.AddPool(pool)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: POOLADDEDIT_COMPLETED
          })
          dispatch(addInfoNotification('Pool Added'))
          dispatch(push('/pools'))
        }
        else if (response.status === 409) {
          throw new Error("Pool ID already exists")
        }
        else {
          throw new Error()
        }
      })
      .catch(error => {
        dispatch({
          type: POOLADDEDIT_ERROR,
          payload: error.message
        })
        dispatch(addErrorNotification('Error adding pool', error.message))
        console.log('Catch fetch error: ', error)
      })
  }
}

export const updatePool = (pool) => {
  return dispatch => {
    dispatch({
      type: POOLADDEDIT_REQUESTED,
      payload: pool
    })

    PoolsApi.EditPool(pool)
      .then(() => {
        dispatch({
          type: POOLADDEDIT_COMPLETED
        })
        dispatch(addInfoNotification('Pool updated'))
        dispatch(push('/pools'))
      })
      .catch(error => {
        dispatch({
          type: POOLADDEDIT_ERROR,
          payload: error.message
        })
        dispatch(addErrorNotification('Error updating pool', error.message))
        console.log('Catch fetch error: ', error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/poolAddEdit.js